import { objectToQueryString } from '../utils/object'
import api from './base'

export default {
  get ({ businessUnitId, articleId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/article_card/${articleId}?${objectToQueryString(filters)}`)
  },
  getPdf ({ businessUnitId, articleId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/article_card/${articleId}/pdf?${objectToQueryString(filters)}`)
  }
}
